import React, { useState } from "react";
import { Form, Tree } from "antd";
import { inject, observer } from "mobx-react";

import classNames from "classnames";

import { FormContext } from "../index";

import "../style/filterJob.scss";

const { TreeNode } = Tree;

export const recruitTypeOptions = [
  { title: "秋季校园招聘", key: "XZ-02,RM-09" },
  { title: "大咖招聘计划", key: "DN-08" },
  { title: "实习生招聘", key: "SXS-03" },
  { title: "社会招聘", key: "SZ-01,LX-04,JZ-05,GW-06,WB-07" },
];

const ListMapping = [
  {
    id: "type",
    text: "招聘项目",
    initOpenState: true,
    options: recruitTypeOptions,
  },
  {
    id: "category",
    text: "职位类别",
    initOpenState: false,
    options: "positionCategory",
  },
  {
    id: "team",
    text: "团队",
    initOpenState: false,
    options: "teamEnum",
  },
  {
    id: "city",
    text: "工作城市",
    initOpenState: false,
    options: "workCity",
  },
];

const PrimaryFilter = (props) => {
  const { text, children, initOpenState } = props;

  const [openState, setOpenState] = useState(initOpenState);

  const handleOnClick = () => {
    setOpenState(!openState);
  };

  return (
    <div className="primaryFilter">
      <div className="primaryFilter__operate" onClick={handleOnClick}>
        <div className="primaryFilter__operate--title">{text}</div>
        <div className="primaryFilter__operateBox">
          <div
            className={classNames(
              "primaryFilter__operateBox--dog",
              openState
                ? "primaryFilter__operateBox--dogActive"
                : "primaryFilter__operateBox--dogPassive"
            )}
          />
          <div
            className={classNames(
              "primaryFilter__operateBox--cat",
              openState
                ? "primaryFilter__operateBox--catActive"
                : "primaryFilter__operateBox--catPassive"
            )}
          />
        </div>
      </div>
      <div
        className={classNames(
          "primaryFilter__content",
          openState
            ? "primaryFilter__content--show"
            : "primaryFilter__content--hidden"
        )}
      >
        {children}
      </div>
    </div>
  );
};

@inject("commonStore")
@observer
class FilterJob extends React.Component {
  resetIds = ["type", "category", "team", "city"];

  formatCategoryData = (options) => {
    if (Array.isArray(options) && options.length > 0) {
      return options.map((item) => {
        const { description, id, children } = item;
        if (Array.isArray(children) && children.length > 0) {
          return {
            title: description,
            key: id,
            children: this.formatCategoryData(children),
          };
        }
        return {
          title: description,
          key: id,
        };
      });
    }
  };

  formatTeamData = (options) => {
    if (Array.isArray(options) && options.length > 0) {
      return options
        .map((item) => {
          const { code, enumLongNote, children } = item;
          if (Array.isArray(children) && children.length > 0) {
            return {
              title: enumLongNote,
              key: code,
              children: this.formatTeamData(children),
            };
          }
          return {
            title: enumLongNote,
            key: code,
          };
        })
        .filter((item) => item.key !== "T1002");
    }
  };

  formatCityData = (options) => {
    if (Array.isArray(options) && options.length > 0) {
      return options.map((item) => {
        const { locCode, cityName, children } = item;
        if (Array.isArray(children) && children.length > 0) {
          return {
            title: cityName,
            key: locCode,
            children: this.formatCityData(children),
          };
        }
        return {
          title: cityName,
          key: locCode,
        };
      });
    }
  };

  renderTreeNode = (options) => {
    return options.map((item) => {
      const { key, title, children } = item;
      return (
        <TreeNode
          style={{ userSelect: "none" }}
          selectable={false}
          title={title}
          key={key}
        >
          {Array.isArray(children) && children.length > 0
            ? this.renderTreeNode(children)
            : null}
        </TreeNode>
      );
    });
  };

  renderTreeSelect = (getFieldDecorator, formKey, options, searchJob) => {
    let optionsData;
    switch (formKey) {
      case "category":
        optionsData = this.formatCategoryData(options);
        break;
      case "team":
        optionsData = this.formatTeamData(options);
        break;
      case "city":
        optionsData = this.formatCityData(options);
        break;
      case "type":
        optionsData = options;
        break;
      default:
        return null;
    }
    return (
      <Form.Item>
        {getFieldDecorator(formKey, {
          trigger: "onCheck",
          valuePropName: "checkedKeys",
        })(
          <Tree
            className={`primaryFilter__content--${formKey}`}
            onCheck={(selectedKeys, e) => {
              this.handleCheckTree(formKey, selectedKeys, e);
              searchJob();
            }}
            checkable
          >
            {this.renderTreeNode(optionsData)}
          </Tree>
        )}
      </Form.Item>
    );
  };

  checkTagMap = {
    type: "searchPositionByProject",
    category: "searchPositionByCategory",
    team: "searchPositionByTeam",
    city: "searchPositionByCity",
  };

  handleCheckTree = (formKey, selectedKeys, e) => {
    try {
      this.props.commonStore.gTag("event", this.checkTagMap[formKey], {
        pageName: "personGameApplyInfo",
        buttonName: (e && e.node && e.node.props && e.node.props.title) || "",
      });
    } catch (error) {
      console.error(error);
    }
  };

  renderClear = (form) => {
    const values = form.getFieldsValue();
    const valuesKeys = Object.keys(form.getFieldsValue()).filter(
      (item) => item !== "query"
    );
    const leng = valuesKeys.reduce((pre, cur) => {
      return pre + (values[cur] ? values[cur].length : 0);
    }, 0);

    return leng > 0 ? `清除（${leng}）` : null;
  };

  clearFilters = (form, searchJob) => {
    form.resetFields(this.resetIds);
    searchJob && searchJob();
  };

  render() {
    const { className, ...restProps } = this.props;

    return (
      <FormContext.Consumer>
        {({ form, searchJob }) => {
          const { getFieldDecorator } = form;

          return form ? (
            <div className={classNames("filterJob", className)}>
              <div className="filterJob__titleBox">
                <div className="filterJob__titleBox--title">{"筛选职位"}</div>
                <div
                  className="filterJob__titleBox--clear"
                  onClick={() => this.clearFilters(form, searchJob)}
                >
                  {this.renderClear(form)}
                </div>
              </div>
              <div className="filterJob--content">
                {ListMapping.map((item, index) => {
                  const options = restProps[item.options] || item.options;

                  return getFieldDecorator &&
                    Array.isArray(options) &&
                    options.length > 0 ? (
                    <PrimaryFilter
                      text={item.text}
                      initOpenState={item.initOpenState}
                      key={index}
                    >
                      {this.renderTreeSelect(
                        getFieldDecorator,
                        item.id,
                        options,
                        searchJob
                      )}
                    </PrimaryFilter>
                  ) : null;
                })}
              </div>
            </div>
          ) : null;
        }}
      </FormContext.Consumer>
    );
  }
}

export default FilterJob;



// WEBPACK FOOTER //
// ./src/components/formList/gameForm/jobSelect/sliderFunc/filterJob.js